/**
 * Home page contact form: submits to the site's Contact Form 7 form
 * ("Contact form 1", id 57) via CF7's REST feedback endpoint, using the
 * existing markup/styling as-is (no visual changes).
 */
export function initHomeContactForm() {
	const form = document.querySelector('.home-contact-form');

	if (!form) {
		return;
	}

	const endpoint = form.getAttribute('data-cf7-endpoint');

	if (!endpoint) {
		return;
	}

	const submitButton = form.querySelector('.home-contact-form__submit');
	const submitLabel = submitButton && submitButton.querySelector('.home-contact-form__submit-label');
	const status = form.querySelector('.home-contact-form__status');
	const wrap = form.closest('.home-contact-form-wrap');
	const successPanel = wrap && wrap.parentElement.querySelector('.home-contact-form-success');

	form.addEventListener('submit', (event) => {
		event.preventDefault();

		setLoading(submitButton, submitLabel, true);
		setStatus(status, '', null);

		fetch(endpoint, {
			method: 'POST',
			body: new FormData(form),
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((data) => {
				const ok = data && data.status === 'mail_sent';

				if (ok) {
					form.reset();

					if (wrap && successPanel) {
						wrap.classList.add('is-hidden');
						successPanel.classList.remove('is-hidden');
					} else {
						setStatus(status, (data && data.message) || '', 'success');
					}
				} else {
					setStatus(status, (data && data.message) || '', 'error');
				}
			})
			.catch(() => {
				setStatus(status, 'There was an error trying to send your message. Please try again later.', 'error');
			})
			.finally(() => {
				setLoading(submitButton, submitLabel, false);
			});
	});
}

function setLoading(submitButton, submitLabel, isLoading) {
	if (!submitButton) {
		return;
	}

	submitButton.disabled = isLoading;
	submitButton.classList.toggle('is-loading', isLoading);

	if (submitLabel) {
		const key = isLoading ? 'labelLoading' : 'labelDefault';
		submitLabel.textContent = submitButton.dataset[key] || submitLabel.textContent;
	}
}

function setStatus(statusEl, message, state) {
	if (!statusEl) {
		return;
	}

	statusEl.textContent = message;
	statusEl.classList.remove('home-contact-form__status--success', 'home-contact-form__status--error');

	if (state) {
		statusEl.classList.add(`home-contact-form__status--${state}`);
	}
}
